module.exports = __webpack_public_path__ + "static/media/safari-logo.237a7f3b.svg";